import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from "@angular/core";
import { AttachmentService } from "../../services/attachment.service";
import { ConfigService } from "../../services/config.service";
import { EvaluatorResult } from "../../models/evaluator-result";
import { AddinTabs, DangerousExtensionLevelEnum, IAttachmentIndex } from "../../models/shared.model";
import { Subscription } from "rxjs";
import { ScrollToSectionService } from "../../services/scrollToSection.service";
import { WaitService } from "../../services/wait.service";

interface AttachmentObject {
  name: string;
  extension: any;
  index: IAttachmentIndex;
  attachmentLevel: number;
}

@Component({
  selector: "app-attachment",
  templateUrl: "./attachment.component.html",
  encapsulation: ViewEncapsulation.None
})
export class AttachmentComponent implements OnInit, OnDestroy, OnChanges {
  @Input() incomplete = false;

  @Input("attachmentsResult") attachmentsResult: EvaluatorResult[];
  private scrollSubscription!: Subscription;

  attachmentsInfo = [];
  uniqueAttachments: Set<AttachmentObject>;
  attachmentTypes: Set<string>;

  isAnalyzing: boolean = true;

  constructor(
    private attachmentService: AttachmentService,
    private configService: ConfigService,
    private el: ElementRef,
    private scrollToSectionService: ScrollToSectionService,
    private waitService: WaitService,
  ) {
    this.isAnalyzing = this.waitService.isAnalyzing;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["attachmentsResult"]?.currentValue) {
      this.attachmentsResult = changes["attachmentsResult"]?.currentValue;
      this.processAttachments();
    }
  }

  ngOnInit(): void {
    this.scrollSubscription = this.scrollToSectionService.scrollToSection$.subscribe((scrollTo) => {
      if (scrollTo.tab == AddinTabs.ATTACHMENTS)
        this.scrollToSection(scrollTo.id, scrollTo?.decision);
    });

    this.waitService.resetData.subscribe((reset) => {
      if (reset) {
        this.attachmentsInfo = [];
        this.uniqueAttachments = new Set<any>();
        this.attachmentTypes = new Set<string>();
      }
    });

    this.waitService.isAnalyzingObserver.subscribe((isAnalyzing) => {
      this.isAnalyzing = isAnalyzing;
    });

    if (this.attachmentsResult)
      this.processAttachments();

  }

  private processAttachments(): void {
    this.attachmentsInfo = [];
    this.uniqueAttachments = new Set<any>();
    this.attachmentTypes = new Set<string>();

    this.attachmentsResult.forEach(value => {
      this.attachmentsInfo.push(value.additionalInfo);
      let attachment = value.additionalInfo.attachment;
      let ext = this.attachmentService.parseAttachmentExtension(attachment);

      let obj: AttachmentObject = {
        name: attachment.name,
        extension: ext,
        index: this.configService.getAttachmentIndexConfiguration(ext),
        attachmentLevel: value.additionalInfo.attachmentLevel
      };

      this.uniqueAttachments.add(obj);
      this.attachmentTypes.add(ext);
    });
  }

  getAttachmentTypes() {
    return Array.from(this.attachmentTypes).join(", ");
  }

  scrollToSection(sectionId: string, dangerLevel?: string) {
    let idOfAttachment = -1;
    let uniqueAttachmentsArr = Array.from(this.uniqueAttachments);

    if(dangerLevel) {
      let level = DangerousExtensionLevelEnum[dangerLevel];

      idOfAttachment = uniqueAttachmentsArr.findIndex(value => value.attachmentLevel === level);
    }
    else {
      let attachment = uniqueAttachmentsArr.reduce(function(prev, current) {
        return (prev && prev.attachmentLevel > current.attachmentLevel) ? prev : current
      })

      idOfAttachment = uniqueAttachmentsArr.findIndex(value => value.name === attachment.name);
    }
    const targetElement = this.el.nativeElement.querySelector(`[id="${sectionId}-${idOfAttachment}"]`);

    if (targetElement) {
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
        this.scrollToSectionService.applyHighlight(targetElement);
      }, 200);
    }
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }
}


